import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  IconButton,
  Typography
} from "@mui/material";
import {
  DayOffSection,
  HolidaysSection,
  SectionDelimiter,
  WorkingTimeSection
} from 'src/components/SideBar/CalendarSideBar/components';

import {
  CloseIcon,
  DrawerGalleryEmptyBannerIcon,
  DrawerGalleryEmptyLogoIcon,
  PenMenuIcon
} from "../../Icons";
import {
  setStudioDialogParams,
  showStudioDialog,
} from "../../store/reducers/dialogSlice";
import { closeDrawer } from "../../store/reducers/drawerSlice";
import { resetSelectedRow } from "../../store/reducers/tableSlice";
import { RightDrawerServicePanel } from "../Selector/CustomRightDrawerServicePanel";

enum imagesTypes {
  Banner,
  Logo,
}

export const RightStudioDrawer = () => {
  const dispatch = useDispatch();

  const { isShown } = useSelector((state: any) => state.drawer);
  const { selectedRow: rowData } = useSelector((state: any) => state.table);

  const handleClose = () => {
    dispatch(resetSelectedRow());
    dispatch(closeDrawer());
  };

  const getBasicEditParams = () => {
    return {
      step: 0,
      maxAvailableStep: 5,
      isEdit: true,
      data: rowData,
    };
  };

  const handleEditAllButton = () => {
    handleClose();
    setTimeout(() => {
      dispatch(setStudioDialogParams(getBasicEditParams()));
      dispatch(showStudioDialog());
    }, 100);
  };

  const handleEditBasicInfoButton = () => {
    handleClose();
    dispatch(setStudioDialogParams(getBasicEditParams()));
    dispatch(showStudioDialog());
  };

  const handleEditAssignButton = () => {
    handleClose();
    dispatch(
      setStudioDialogParams({
        ...getBasicEditParams(),
        step: 1,
      })
    );
    dispatch(showStudioDialog());
  };

  const handleEditTimetableButton = () => {
    handleClose();
    dispatch(
      setStudioDialogParams({
        ...getBasicEditParams(),
        step: 2,
      })
    );
    dispatch(showStudioDialog());
  };

  const isImageExist = (image: string | undefined) => {
    return image !== "" && image != null;
  };

  return (
    <Box
      sx={{
        position: "fixed",
        width: "424px",
        height: "auto",
        zIndex: 1000,
        backgroundColor: "#F3F3F3",
        top: 82,
        right: "0px",
        display: isShown ? "block" : "none",
        transition: "right 0.3s",
        boxShadow: isShown
          ? "rgba(0, 0, 0, 0.1) -3px 10px 15px 0px"
          : undefined,
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          height: "62px",
          backgroundColor: "white",
          padding: "10px 16px",
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            width: "32px",
            height: "32px",
            borderRadius: "6px",
            backgroundColor: "#F3F3F3",
            color: "#676767",
            fontSize: "20px",
          }}
          disableRipple
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>
        <Box>
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
            }}
          >
            About studio
          </Typography>
        </Box>
        <Button
          sx={{
            fontSize: "14px",
            fontWeight: "400",
          }}
          onClick={handleEditAllButton}
          disableRipple
        >
          Edit all
        </Button>
      </Box>

      <Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            position: "relative",
            width: "100%",
            flex: 1,
            height: 168,
          }}
        >
          {isImageExist(
            rowData.images && rowData.images[imagesTypes.Banner]
          ) ? (
              <Box>
                <img
                  src={rowData.images[imagesTypes.Banner]}
                  style={{
                    width: "100%",
                    height: 168,
                    objectFit: "cover",
                  }}
                />
              </Box>
            ) : (
              <Box
                sx={{
                  padding: 0,
                  backgroundColor: "#fafafa",
                  borderRadius: 0,
                  border: "none",
                  boxShadow: "none",
                  width: "100%",
                  height: 168,
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flex: 1,
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                    fontSize: "56px",
                    color: "#D6D6DB",
                  }}
                >
                  <DrawerGalleryEmptyBannerIcon fontSize="inherit" />
                </Box>
              </Box>
            )}
        </Box>
        <Box
          sx={{
            display: "flex",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              padding: "0px 16px 0",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
                width: 136,
                height: 136,
                top: "-88px",
                left: "16px",
                marginBottom: "-88px",
              }}
            >
              <Box
                sx={{
                  width: 136,
                  height: 136,
                  borderRadius: "50%",
                  backgroundColor: "#F3F3F3",
                  border: "8px solid transparent",
                  display: "flex",
                }}
              >
                {isImageExist(
                  rowData.images && rowData.images[imagesTypes.Logo]
                ) ? (
                    <img
                      src={rowData.images[imagesTypes.Logo]}
                      style={{
                        width: 120,
                        height: 120,
                        objectFit: "fill",
                        borderRadius: "50%",
                        top: "-5px",
                      }}
                    />
                  ) : (
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                        justifyContent: "center",
                        width: 120,
                        height: 120,
                        borderRadius: "50%",
                        backgroundColor: "#fafafa",
                        color: "#D6D6DB",
                        fontSize: "40px",
                        top: "-5px",
                      }}
                    >
                      <DrawerGalleryEmptyLogoIcon fontSize="inherit" />
                    </Box>
                  )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          height: "calc(100vh - 82px - 62px - 168px - 48px)",
          overflowY: "auto",
        }}
      >
        <Box
          display="flex"
          sx={{
            padding: "16px 16px",
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            sx={{
              backgroundColor: "white",
              flex: 1,
              borderRadius: "6px",
              padding: "16px 16px 24px",
              boxShadow: "0px 4px 16px 0px rgba(41, 66, 90, 0.12)",
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                flex: 1,
                marginBottom: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Basic information
              </Typography>

              <IconButton
                onClick={handleEditBasicInfoButton}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#BF295C",
                  fontSize: "16px",
                }}
                disableRipple
              >
                <PenMenuIcon fontSize="inherit" />
              </IconButton>
            </Box>

            <Box
              sx={{
                marginBottom: "16px",
              }}
            >
              <Typography
                sx={{
                  textTransform: "uppercase",
                  fontSize: "12px",
                  color: "#828282",
                }}
              >
                Name
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#080808",
                }}
              >
                {rowData.title}
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  textTransform: "uppercase",
                  fontSize: "12px",
                  color: "#828282",
                }}
              >
                Address
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#080808",
                }}
              >
                {rowData.address}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          display="flex"
          sx={{
            padding: "0 16px 16px",
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            sx={{
              backgroundColor: "white",
              flex: 1,
              borderRadius: "6px",
              padding: "16px 16px 24px",
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 10px 0px",
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                flex: 1,
                marginBottom: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Management
              </Typography>

              <IconButton
                onClick={handleEditAssignButton}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#BF295C",
                  fontSize: "16px",
                }}
                disableRipple
              >
                <PenMenuIcon fontSize="inherit" />
              </IconButton>
            </Box>
            <Box sx={{
              display: 'flex',
            }}>
              <Box
                sx={{
                  marginBottom: "16px",
                  flex: 0.7,
                }}
              >
                <Typography
                  sx={{
                    textTransform: "uppercase",
                    fontSize: "12px",
                    color: "#828282",
                  }}
                >
                  Admins
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#080808",
                  }}
                >
                  {rowData?.admins?.length === 0
                    ? "Not selected"
                    : `${rowData?.admins?.length} admin${rowData?.admins?.length === 1 ? '' : 's'}`}
                </Typography>
              </Box>
              <Box>
                <Typography
                  sx={{
                    textTransform: "uppercase",
                    fontSize: "12px",
                    color: "#828282",
                  }}
                >
                  Employees
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#080808",
                  }}
                >
                  {rowData?.masters?.length === 0
                    ? "Not selected"
                    : `${rowData?.masters?.length} employee${rowData?.masters?.length === 1 ? '' : 's'}`}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          display="flex"
          sx={{
            padding: "0 16px 16px",
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            sx={{
              backgroundColor: "white",
              flex: 1,
              borderRadius: "6px",
              padding: "16px 16px 24px",
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 10px 0px",
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                flex: 1,
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Schedule rules
              </Typography>

              <IconButton
                onClick={handleEditTimetableButton}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#BF295C",
                  fontSize: "16px",
                }}
                disableRipple
              >
                <PenMenuIcon fontSize="inherit" />
              </IconButton>
            </Box>
            <Box>
              <WorkingTimeSection
                workingTimes={rowData?.schedule?.workingTimes}
                onClick={handleEditTimetableButton}
              />
              <SectionDelimiter />
              <HolidaysSection
                onClick={handleEditTimetableButton}
                holidays={rowData?.schedule?.holidays}
                lastUpdated={rowData?.schedule?.updatedAt}
              />
              <SectionDelimiter />
              <DayOffSection
                onClick={handleEditTimetableButton}
                daysOff={rowData?.schedule?.daysOff}
              />
            </Box>
          </Box>
        </Box>
        <RightDrawerServicePanel
          location='drawer'
          categoriesList={rowData.categories}
          rowData={rowData}
        />
      </Box>
    </Box>
  );
};
